// Generated from SVG to Code Figma Plugin

export const BaseLineIconview = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.12245 3H4.02041C3.45685 3 3 3.45685 3 4.02041V9.12245C3 9.68602 3.45685 10.1429 4.02041 10.1429H9.12245C9.68602 10.1429 10.1429 9.68602 10.1429 9.12245V4.02041C10.1429 3.45685 9.68602 3 9.12245 3Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M9.12245 13.8569H4.02041C3.45685 13.8569 3 14.3138 3 14.8773V19.9794C3 20.543 3.45685 20.9998 4.02041 20.9998H9.12245C9.68602 20.9998 10.1429 20.543 10.1429 19.9794V14.8773C10.1429 14.3138 9.68602 13.8569 9.12245 13.8569Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M19.9799 3H14.8778C14.3143 3 13.8574 3.45685 13.8574 4.02041V9.12245C13.8574 9.68602 14.3143 10.1429 14.8778 10.1429H19.9799C20.5434 10.1429 21.0003 9.68602 21.0003 9.12245V4.02041C21.0003 3.45685 20.5434 3 19.9799 3Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M19.9799 13.8569H14.8778C14.3143 13.8569 13.8574 14.3138 13.8574 14.8773V19.9794C13.8574 20.543 14.3143 20.9998 14.8778 20.9998H19.9799C20.5434 20.9998 21.0003 20.543 21.0003 19.9794V14.8773C21.0003 14.3138 20.5434 13.8569 19.9799 13.8569Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
